module.exports = __webpack_public_path__ + "img/chanpin2.e80fc932.png";